import { animate, style, transition, trigger } from '@angular/animations';
import { Component, computed, inject, input } from '@angular/core';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService } from '@features/styles/styles.service';
import { EASE_IN_BACK, EASE_OUT_BACK } from '@shared/css.utils';

@Component({
  selector: 'app-canvas-arrow',
  imports: [StyleSheetSpriteComponent],
  templateUrl: './canvas-arrow.component.html',
  styleUrl: './canvas-arrow.component.css',
  animations: [
    trigger('scale', [
      transition(':enter', [style({ scale: 0 }), animate(`0.25s ${EASE_OUT_BACK}`, style({ scale: 1 }))]),
      transition(':leave', [style({ scale: 1 }), animate(`0.25s ${EASE_IN_BACK}`, style({ scale: 0 }))]),
    ]),
  ],
})
export class CanvasArrowComponent {
  readonly _stylesService = inject(StylesService);

  doShow = input.required<boolean>();
  anchor = input.required<'top' | 'right' | 'bottom' | 'left'>();

  position = computed(() => {
    switch (this.anchor()) {
      case 'top':
        return { top: '0', left: '50%', transform: 'translateX(-50%)', 'transform-origin': '0 0' };
      case 'right':
        return { right: '0', top: '50%', transform: 'translateY(-50%)', 'transform-origin': '100% 0' };
      case 'bottom':
        return { bottom: '0', left: '50%', transform: 'translateX(-50%)', 'transform-origin': '0 100%' };
      case 'left':
        return { top: '50%', left: '0', transform: 'translateY(-50%)', 'transform-origin': '0 0' };
    }
  });
  offset = computed(() => {
    const offset = 10;
    switch (this.anchor()) {
      case 'top':
        return `0px, ${-offset}px`;
      case 'right':
        return `${offset}px, 0px`;
      case 'bottom':
        return `0px, ${offset}px`;
      case 'left':
        return `${-offset}px, 0px`;
    }
  });
  arrowStyle = computed(() => {
    switch (this.anchor()) {
      case 'top':
        return {
          transform: `rotate(-90deg)`,
        };
      case 'right':
        return {};
      case 'bottom':
        return { transform: `rotate(90deg)` };
      case 'left':
        return { transform: `scaleX(-1)` };
    }
  });
}
